// extracted by mini-css-extract-plugin
export default {"SignInButton":"SignInButton_SignInButton__5Pxmu"};